import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import {DeviceProvider} from "./context/deviceContext";
import ukUA from 'antd/locale/uk_UA'
import {ConfigProvider} from 'antd'
import dayjs from 'dayjs'
import updateLocale from 'dayjs/plugin/updateLocale'
import 'dayjs/locale/uk'

dayjs.extend(updateLocale)

dayjs.updateLocale('uk', {
  weekStart: 1,
})

dayjs.locale('uk')

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <ConfigProvider locale={ukUA}>
      <DeviceProvider>
        <App/>
      </DeviceProvider>
    </ConfigProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
